import { ShoppingScreen } from '@/features/shopping/components/shopping-screen';

export function ShoppingPage() {
  return <ShoppingScreen />;
}
